export const LISTS = "/api/pa/lists";
export const LIST = "/api/pa/lists/:param";
